import { zfUtils } from "./zf_utils";
import { zfc3d } from "./zfc_3dmodel";
import { zfcCharts } from "./zfc_chart";
import { zfc } from "./zfc_global";
import { Swiper, Navigation, Pagination, A11y } from "./swiper-config";
export class zfcgs {
    static initSlick(main) {
        try {
            var slider = main.find(".zfcgs-container");
            var includeSwipe = main.find(".zfc3d-model").length == 0 &&
                main.find(".zfcmap").length == 0
                ? true
                : false;
            var scrollSlides = 1;
            var showSlides = 1;
            var ttSpacing = 0;
            if (slider.find(".zfcgs-content-row").children(":not(.swiper-slide)")
                .length > 0) {
                slider
                    .find(".zfcgs-content-row")
                    .children(":not(.swiper-slide)")
                    .addClass("swiper-slide");
            }
            scrollSlides = 1;
            if (slider.find(".zfctf-teasers-card-50").length > 0 ||
                slider.find(".text4-img8").length > 0 ||
                slider.find(".zfctt-teaser-m").length > 0) {
                showSlides = 2;
                ttSpacing = 0.02;
            }
            else if (slider.find(".zfctf-teasers-card-33").length > 0 ||
                slider.find(".text5-img7").length > 0 ||
                slider.find(".zfctt-teaser-s").length > 0) {
                showSlides = 3;
                ttSpacing = 0.02;
            }
            else if (slider.find(".zfctf-teasers-card-25").length > 0 ||
                slider.find(".text7-img5").length > 0 ||
                slider.find(".zfctt-teaser-xs").length > 0) {
                showSlides = 4;
                ttSpacing = 0.02;
            }
            var totalSlides = slider.find(".zfcgs-content-row .swiper-slide").length;
            var tabletSlidesPerView = slider.find(".zfctt-teaser-xs").length > 0 ||
                slider.find(".zfctf-teasers-card-25").length > 0
                ? 2
                : 1;
            var nextBtn = document.getElementById(slider.parent().attr("id") + "_next_btn");
            var prevBtn = document.getElementById(slider.parent().attr("id") + "_prev_btn");
            if (!slider.hasClass("swiper-initialized")) {
                const swiper = new Swiper("#" + slider.attr("id"), {
                    modules: [Navigation, Pagination, A11y],
                    spaceBetween: slider.find(".zfctf-teasers").length > 0 ||
                        slider.find(".zfctt-teasers").length > 0
                        ? ttSpacing + "% - 20"
                        : 40,
                    loop: false,
                    normalizeSlideIndex: true,
                    noSwipingSelector: '.playkit-control-button',
                    preventClicks: false,
                    preventClicksPropagation: false,
                    breakpoints: {
                        960: {
                            allowTouchMove: false,
                            slidesPerView: showSlides,
                            navigation: {
                                enabled: totalSlides > showSlides,
                                nextEl: nextBtn,
                                prevEl: prevBtn,
                            },
                            pagination: {
                                enabled: true,
                                el: ".swiper-pagination",
                                type: "custom",
                                clickable: true,
                                renderCustom: function (swiper, current, total) {
                                    var out = "";
                                    for (var i = 1; i < total + 1; i++) {
                                        if (i == current) {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet swiper-pagination-bullet-active" role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                        else {
                                            out =
                                                out +
                                                    '<button class="swiper-pagination-bullet" role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></button>';
                                        }
                                    }
                                    return out;
                                },
                            },
                        },
                        720: {
                            allowTouchMove: true,
                            slidesPerView: tabletSlidesPerView,
                            navigation: {
                                enabled: totalSlides > tabletSlidesPerView,
                                nextEl: nextBtn,
                                prevEl: prevBtn,
                            },
                            pagination: {
                                enabled: true,
                                el: ".swiper-pagination",
                                type: "custom",
                                clickable: true,
                                renderCustom: function (swiper, current, total) {
                                    var out = "";
                                    for (var i = 1; i < total + 1; i++) {
                                        if (i == current) {
                                            out =
                                                out +
                                                    '<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex=' +
                                                    i +
                                                    ' role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></span>';
                                        }
                                        else {
                                            out =
                                                out +
                                                    '<span class="swiper-pagination-bullet" tabindex=' +
                                                    i +
                                                    ' role="button" aria-label="Go to slide ' +
                                                    i +
                                                    1 +
                                                    '"></span>';
                                        }
                                    }
                                    return out;
                                },
                            },
                        },
                        0: {
                            allowTouchMove: true,
                            slidesPerView: 1,
                            navigation: {
                                enabled: false,
                                nextEl: nextBtn,
                                prevEl: prevBtn,
                            },
                            pagination: {
                                enabled: true,
                                el: '.swiper-pagination',
                                clickable: false,
                                dynamicBullets: true,
                                dynamicMainBullets: 1
                            },
                        },
                    },
                    a11y: {
                        enabled: true,
                        nextSlideMessage: "Next slide",
                        prevSlideMessage: "Previous slide",
                        paginationBulletMessage: "Jump to slide {{index}}",
                        slideLabelMessage: "Slide {{index}} of {{slidesLength}}",
                        slideRole: "group",
                        itemRoleDescriptionMessage: "slide",
                    },
                });
            }
            var btnClass = ".swiper-button-prev, .swiper-button-next";
            if ((slider.find(".zfctf-teasers").length > 0 ||
                slider.find(".zfctt-teasers").length > 0 ||
                slider.find(".zfctt-teaser-l").length > 0)) {
                $(".swiper-button-prev").addClass("general-slider-arrow-prev");
                $(".swiper-button-next").addClass("general-slider-arrow-next");
            }
            if (slider.attr("id").indexOf("general_slider_videos") == 0) {
                slider
                    .find(".swiper-button-prev, .swiper-button-next")
                    .off("click.zfcgsPause")
                    .on("click.zfcgsPause", function () {
                    zfcgs.pauseVideos(slider);
                });
            }
            if (slider.find(".zfc3d-3d-model").length > 0) {
                zfcgs.loadModel(slider);
                slider
                    .find(btnClass)
                    .off("click.zfcgsModel")
                    .on("click.zfcgsModel", function () {
                    zfcgs.loadModel(slider);
                });
            }
            else if (slider.find(".zfc3d-canvas").length > 0) {
                zfcgs.loadModel(slider);
                slider
                    .find(btnClass)
                    .off("click.zfcgsModel")
                    .on("click.zfcgsModel", function () {
                    zfcgs.loadModel(slider);
                });
            }
            if (slider.find(".zfcc-charts").length > 0) {
                zfcgs.loadChart(slider);
                slider
                    .find(btnClass)
                    .off("click.zfcgsChart")
                    .on("click.zfcgsChart", function () {
                    zfcgs.loadChart(slider);
                });
                slider.off("afterChange.zfcgsChart").on("afterChange.zfcgsChart", function () {
                    $(this)
                        .find(".zfcc-charts.swiper-slide-active .zfcc-charts-canvas")
                        .removeClass("chartjs-render-monitor");
                    setTimeout(function () {
                        $(this)
                            .find(".zfcc-charts.swiper-slide-active .zfcc-charts-canvas")
                            .addClass("chartjs-render-monitor");
                    }, 1000);
                });
            }
            main.addClass("zfcgs-initialized");
        }
        catch (err) {
            console.log("Initalization failed: zfcgs.initSlick() " + err.message);
        }
    }
    static pauseVideos(slider) {
        slider.find("video-js.vjs-playing").each(function () {
            $(this).find("video").get(0).pause();
        });
    }
    static loadChart(slider) {
        var currChart = slider.find(".zfcc-charts.swiper-slide-active");
        if (!currChart.hasClass("delayZFCChartsLoad")) {
            zfUtils.loadOnScroll(currChart, "delayZFCChartsLoad", zfcCharts.init, 1);
        }
    }
    static loadModel(slider) {
        var currModel = slider.find(".zfcgs-general-slider-item.swiper-slide-active > .zfc3d-model > .zfc3d-3d-model").length
            ? slider.find(".zfcgs-general-slider-item.swiper-slide-active > .zfc3d-model > .zfc3d-3d-model")
            : slider.find(".zfcgs-general-slider-item.swiper-slide-active > .zfc3d-model > .zfc3d-canvas");
        if (currModel.find(".zfc3d-viewer").length > 0 &&
            !currModel.find(".zfc3d-viewer").children().length) {
            zfUtils.loadOnScroll(currModel, "delayZFC3DLoad", zfc3d.init, 1);
        }
        else if ($(currModel).hasClass("zfc3d-canvas")) {
            zfUtils.loadOnScroll($(currModel), "delayZFC3DCanvasLoad", zfc3d.initZFCanvas, 1);
        }
    }
    static init() {
        $(".zfcgs-general-slider:not(.zfcgs-initialized)").each(function () {
            if ($(this).closest(".zfcacc-accordion-content-component").length == 0 ||
                $(this).closest(".zfcacc-accordion-content-component").is(":visible")) {
                zfUtils.loadOnScroll($(this), "delayZFCGSLoad", zfcgs.initSlick);
            }
        });
        zfc.modalCallbacks[".zfcgs-general-slider"] = zfcgs.initSlick;
    }
}
try {
    zfUtils.onReady(zfcgs.init);
}
catch (err) {
    console.log("Initalization failed: zfcgs.init() " + err.message);
}
